<template>
  <div class="d-flex flex-column">
    <b-table
      :items="list"
      :fields="fields"
      :busy="isBusy"
      responsive
      show-empty
      hover
      id="group-membership-available-table"
      ref="group-membership-available-table"
      table-class="table-head-custom table-vertical-center table-head-bg mt-5"
      @row-clicked="handleCheckBox"
    >
      <!-- begin: t-head -->
      <template v-slot:head(index)="data">
        <span class="text-dark-75">{{ data.label.toUpperCase() }}</span>
      </template>
      <!-- end: t-head -->

      <!-- begin: t-row -->
      <template v-slot:cell(index)="data">
        <div class="d-flex mt-1 mb-2">
          <b-form-checkbox
            size="lg"
            v-model="employeeChecked"
            :value="data.item.id"
            @change="handleCheckBox(data.item, false)"
            class="h6 mr-3"
          ></b-form-checkbox>
        </div>
      </template>

      <template v-slot:cell(employee)="data">
        <CommonEmployeeSummary
          :item="generateSummary(data.item)"
        ></CommonEmployeeSummary>
      </template>

      <!-- end: t-row -->

      <template #table-busy>
        <AppLoader></AppLoader>
      </template>

      <template #empty>
        <AppEmptyList
          text-top="No Available Teacher"
          text-bottom="No Teacher are available to be added to this group. Please check whether there are no existing registered teacher."
        ></AppEmptyList>
      </template>
    </b-table>

    <b-pagination
      pills
      size="lg"
      class="align-self-end"
      v-model="pagination.current_page"
      :total-rows="pagination.total"
      :per-page="pagination.per_page"
      @change="change"
    >
    </b-pagination>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppLoader from "@/modules/core/components/loaders/AppLoader";
import CommonEmployeeSummary from "@/modules/core/components/company/CommonEmployeeSummary";
import AppEmptyList from "@/modules/core/components/empty/AppEmptyList";

export default {
  name: "TeacherMembershipAvailableTable",
  components: { AppEmptyList, CommonEmployeeSummary, AppLoader },
  props: ["reload"],
  data: function () {
    return {
      page: 1,
      fields: [
        { key: "index", label: "#" },
        { key: "employee", label: this.$t("GROUP.GENERAL.NAME") },
      ],
      employeeChecked: [],
      isBusy: false,
    };
  },

  methods: {
    fetch() {
      this.isBusy = true;
      this.$store
        .dispatch("fetchTeacherGroupMemberNotInList", {
          id: this.group.id,
        })
        .finally(() => (this.isBusy = false));
    },

    /**
     * Change page.
     *
     * @param page
     */
    change(page) {
      console.log("Change page to ", page);
      this.$store.commit("setTeacherGroupMemberNotInListPage", page);
      this.fetch();
    },

    /**
     * Generate summary
     *
     * @param item
     */
    generateSummary(item) {
      console.log("Teacher :", item);

      return {
        image_url: item.image_url,
        name: `${item.first_name} ${item.last_name}`,
        code: item.unique_code,
        email: item.email,
      };
    },

    /**
     * Checkbox method.
     *
     * @param row
     * @param checkExists
     */
    handleCheckBox(row, checkExists) {
      console.log(row);
      console.log(this.employeeChecked);

      const exists = this.employeeChecked.includes(row.id);
      console.log("Row exists:", row.id, exists);

      if (exists && checkExists) {
        this.employeeChecked = this.employeeChecked.filter(function (value) {
          console.log("Checked value: ", value, row.id);
          const matched = value === row.id;
          console.log("Matched? ", matched);

          return value !== row.id;
        });
      } else this.employeeChecked.push(row.id);

      this.$store.dispatch("selectTeacherGroupMemberSaveModification", {
        id: row.id,
      });
    },
  },
  mounted() {
    this.fetch();
  },
  watch: {
    reload() {
      this.fetch();
    },
  },
  computed: {
    ...mapGetters({
      list: "getTeacherGroupMemberNotInList",
      pagination: "getTeacherGroupMemberNotInListPagination",
      group: "fetchGroup",
    }),
  },
};
</script>

<style scoped></style>
